import { render } from "./ScheduleItem.vue?vue&type=template&id=5e3dfee9"
import script from "./ScheduleItem.vue?vue&type=script&lang=js"
export * from "./ScheduleItem.vue?vue&type=script&lang=js"

import "./ScheduleItem.vue?vue&type=style&index=0&id=5e3dfee9&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__